<template>
  <div>
    <vs-card class="mb-6">
      <form role="form" @submit.stop.prevent="buscar">
        <div
          :class="`vx-row ${filtroAvancado == true ? 'pb-10' : 'pb-6 mb-0'}`"
        >
          <!-- Protocolo -->
          <div class="vx-col lg:w-2/12 w-full">
            <span>Protocolo</span>
            <AutoComplete
              size="large"
              customClass="w-full"
              name="codigo"
              id="codigo"
              :configAutoComplete="{ model: 'Eventos', field: 'protocolo' }"
              v-model="formFiltro.idEvento"
            />
          </div>

          <!-- Nome -->
          <div :class="`vx-col lg:w-1/3 w-full`">
            <span>Nome</span>
            <AutoComplete
              size="large"
              customClass="w-full"
              name="Nome"
              id="Nome"
              :configAutoComplete="{ model: 'Eventos', field: 'nome' }"
              v-model="formFiltro.nome"
            />
          </div>

          <!-- CPF/CNPJ -->
          <div class="vx-col lg:w-1/4 w-full">
            <span>CPF/CNPJ</span>
            <AutoComplete
              size="large"
              customClass="w-full"
              name="Cpf Cnpj"
              id="Cpf Cnpj"
              v-model="formFiltro.cpfCnpj"
              :configAutoComplete="{ model: 'Associados', field: 'cpfcnpj' }"
              :minimumCharacters="3"
            />
          </div>

          <!-- Placa -->
          <div :class="`vx-col lg:w-1/4 w-full`">
            <span>Placa</span>
            <AutoComplete
              size="large"
              customClass="w-full"
              name="Placa"
              id="Placa"
              :configAutoComplete="{ model: 'Eventos', field: 'placa' }"
              v-model="formFiltro.placa"
            />
          </div>
        </div>

        <div v-if="filtroAvancado == true">
          <div class="vx-row pb-10">
            <!-- Status -->
            <div class="vx-col lg:w-1/4 w-full">
              <span>Status do Sinistro</span>
              <v-select
                :options="status"
                name="Status"
                id="Status"
                v-model="formFiltro.idStatus"
                :reduce="(item) => item.id"
              ></v-select>
            </div>

            <!-- Tipo Sinistro -->
            <div class="vx-col lg:w-1/4 w-full">
              <span>Motivo do Sinistro</span>
              <v-select
                :options="tiposEvento"
                name="Tipo"
                id="Tipo"
                v-model="formFiltro.idMotivo"
                :reduce="(item) => item.id"
              ></v-select>
            </div>

            <!-- Data Inicial - Sinistro -->
            <div class="vx-col lg:w-1/4 w-full">
              <span>Data do Sinistro - Data Inicial</span>
              <datepicker
                :format="'dd/MM/yyyy'"
                placeholder="DD/MM/YYYY"
                v-model="formFiltro.dataInicial"
                :language="languages"
              ></datepicker>
            </div>

            <!-- Data Final - Sinistro -->
            <div class="vx-col lg:w-1/4 w-full">
              <span>Data do Sinistro - Data Final</span>
              <datepicker
                :format="'dd/MM/yyyy'"
                placeholder="DD/MM/YYYY"
                v-model="formFiltro.dataFinal"
                :language="languages"
              ></datepicker>
            </div>
          </div>

          <div class="vx-row pb-10">
            <!-- Estado -->
            <div class="vx-col lg:w-1/4 w-full">
              <span>Estado</span>
              <v-select
                :options="estados"
                name="Estado"
                id="Estado"
                v-model="formFiltro.estado"
                :reduce="(item) => item.label"
              ></v-select>
            </div>

            <!-- Cidade -->
            <div class="vx-col lg:w-1/4 w-full">
              <span>Cidade</span>
              <v-select
                :options="cidades"
                name="Cidade"
                id="Cidade"
                v-model="formFiltro.cidade"
                :reduce="(item) => item.label"
              ></v-select>
            </div>

            <!-- Analisa -->
            <div class="vx-col lg:w-1/4 w-full">
              <span>Analisa</span>
              <v-select
                :options="listUsurios"
                name="Usuario"
                id="Usuario"
                v-model="formFiltro.idUsuario"
                :reduce="(item) => item.id"
              ></v-select>
            </div>

            <!-- Corretora -->
            <div :class="`vx-col lg:w-1/4 w-full`">
              <span>Corretora</span>
              <v-select
                :options="listRegionais"
                name="Corretora"
                id="Corretora"
                v-model="formFiltro.idRegional"
                :reduce="(item) => item.id"
              ></v-select>
            </div>
          </div>

          <div class="vx-row pb-10">
            <!-- Tipo Apólice -->
            <div :class="`vx-col lg:w-1/4 w-full`">
              <span>Tipo Apólice</span>
              <v-select
                :options="listApolices"
                multiple
                name="Tipo Apólice"
                id="Tipo Apólice"
                v-model="formFiltro.idTipoApolices"
                :reduce="(item) => item.id"
              ></v-select>
            </div>
          </div>
        </div>
      </form>

      <div slot="footer" style="margin-top: -3%">
        <br style="clear: both" />
        <vs-row vs-justify="flex-end">
          <!-- Buscar -->
          <vs-button
            color="success"
            type="filled"
            icon-pack="feather"
            icon="icon-search"
            class="mr-3 mb-2"
            @click="buscar"
            >Buscar</vs-button
          >

          <!-- Filtro Avançado -->
          <vs-button
            @click="filtroAvancado = !filtroAvancado"
            type="gradient"
            color="dark"
            icon-pack="feather"
            icon="icon-sliders"
          ></vs-button>

          <!-- Limpar Filtro -->
          <vs-button
            @click="limparFiltro"
            color="danger"
            type="gradient"
            icon-pack="feather"
            icon="icon-trash-2"
          ></vs-button>
        </vs-row>
      </div>
    </vs-card>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import * as lang from 'vuejs-datepicker/src/locale';
import vSelect from 'vue-select';
import AutoComplete from './../../../../../components/autocomplete/AutoComplete.vue';
import jwt from 'jsonwebtoken';

// Service
import service from './../../../../../services';
import seviceEventos from './../../shared/service';
import notify from './../../../../../utils/notify';
import { DOCUMENT_MASK } from '../../../../../constants/cpfCnpj';

const formFiltro = {
  placa: null,
  nome: null,
  cpfCnpj: '',
  idStatus: null,
  cidade: '',
  estado: '',
  dataInicial: null,
  dataFinal: null,
  idEvento: null,
  idMotivo: null,
  idUsuario: null,
  idRegional: null,
  idTipoApolices: null,
};

export default {
  components: {
    Datepicker,
    'v-select': vSelect,
    AutoComplete,
  },
  watch: {
    async 'formFiltro.estado'() {
      this.formFiltro.cidade = null;
      await this.buscaDadosSelectsCidades();
    },
    async filtroAvancado(value) {
      if (value && !this.status.length) {
        try {
          this.$vs.loading();

          await this.buscaDadosSelects('domUf', 'estados', 'nomeUf', 'codUf');
          await this.buscaDadosSelects(
            'eventosSituacoes',
            'status',
            'nomeStatus',
            'idStatus',
          );
          await this.buscaDadosSelects(
            'eventosMotivos',
            'tiposEvento',
            'nomeMotivo',
            'idMotivo',
          );
          await this.buscaDadosSelects(
            'tipoApolices',
            'listApolices',
            'nome',
            'tipoApoliceId',
          );
          await this.buscaDadosSelectsUsuario();
          await this.buscaDadosFiltros();
        } catch (error) {
          notify.notifyFail(this.$vs, error);
        } finally {
          this.$vs.loading.close();
        }
      }
    },
  },
  data() {
    return {
      DOCUMENT_MASK,
      languages: lang.ptBR,
      filtroAvancado: false,
      estados: [],
      cidades: [],
      regionais: [],
      status: [],
      tiposEvento: [],
      listUsurios: [],
      listRegionais: [],
      listApolices: [],

      formFiltro: { ...formFiltro },
    };
  },
  methods: {
    async buscaDadosSelects(model, array, campoDescricao, campoPK) {
      try {
        const res = await service.getAll('g', {}, `${model}/list/`);

        res.data.forEach((element) => {
          this[array].push({
            id: element[campoPK],
            label: element[campoDescricao],
          });
        });
      } catch (error) {
        notify.notifyFail(this.$vs, error);
        return Promise.reject(error);
      }
    },
    async buscaDadosSelectsCidades() {
      try {
        this.$vs.loading();
        this.cidades = [];

        await this.buscaDadosSelects(
          'domMunicipio',
          'cidades',
          'nomeCidade',
          'idCidade',
        );
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },
    async buscaDadosSelectsUsuario() {
      try {
        this.$vs.loading();
        this.listUsurios = [];

        const res = await seviceEventos.getListUsuarios();
        this.listUsurios = res;
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },
    async buscaDadosFiltros() {
      try {
        this.$vs.loading();

        await service
          .post('cotacao', 'busca-filtros-consultores-regionais', this.decoded)
          .then(({ data }) => {
            data.regionais.forEach((element) => {
              this.listRegionais.push({
                id: element.idRegional,
                label: element.nome,
              });
            });
          });
      } catch (error) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Falha ao buscar filtros',
          text: error,
          color: 'danger',
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    // async buscaDadosSelectRegionais() {
    //   try {
    //     this.$vs.loading();
    //     this.listRegionais = [];

    //     const res = await service.getAll('Usuario', {}, 'regionais-do-usuario');

    //     res.data.forEach((element) => {
    //       this.listRegionais.push({
    //         id: element.id_regional,
    //         label: element.nome,
    //       });
    //     });
    //   } catch (error) {
    //     notify.notifyFail(this.$vs, error);
    //   } finally {
    //     this.$vs.loading.close();
    //   }
    // },
    buscar() {
      this.$emit('filtro', this.formFiltro);
    },
    limparFiltro() {
      this.formFiltro = { ...formFiltro };
      this.buscar();
    },
    getDecoded() {
      const token = localStorage.getItem('user-token');
      if (token) this.decoded = jwt.decode(token);
    },
  },
  created() {
    this.getDecoded();
  },
};
</script>

<style>
.vs__dropdown-toggle {
  padding: 4px 0 6px 0 !important;
}

input.flatpickr-input {
  width: 100%;
}

.vdp-datepicker input {
  width: 100%;
}

.vdp-datepicker__calendar {
  z-index: 900 !important;
}
</style>
